import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/urls';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { pushEvent } from '../utils/dataLayer';

const useCouponData = ({slug, name, page, category, type, limit, order }) => {

    const [coupons, setCoupons] = useState([]);
    const [totalPages, setTotalPages] = useState();
    const [loadingCoupon, setLoadingCoupon] = useState(true);
    const [errorCoupon, setErrorCoupon] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {

        const getCouponData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/coupon`, {
                    params: {
                      slug: slug,
                      name: name || undefined,
                      page: page || undefined,
                      category: category || undefined,
                      type: type || undefined,
                      limit: limit || undefined,
                      order: order || undefined
                    },
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                    },
                  }); 
                  setCoupons(res.data); 
                  setTotalPages(res.data.totalPages)

                  if (!res.data.data || res.data.data.length === 0)  {
                    setErrorCoupon('Não Há cupons nem ofertas para essa categoria/loja');
                  } else {
                    setErrorCoupon(null); 
                  }
                  
            } catch (err)  {
                navigate('/not-found')
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setErrorCoupon(msg);
            } finally {
                setLoadingCoupon(false)
                pushEvent('CupomCarregadoLoadings')
            }
        }

        getCouponData();

    }, [slug, name, page, category, type])
  

   return { coupons, loadingCoupon, errorCoupon, totalPages };
}

export default useCouponData